export const PUSHER_TIMEOUT = 10_000;
export const PUSHER_EVENT = 'client-pusher-event';

/** Endpoint key checked against `CONFIG_PUSHER_ENABLED_ENDPOINTS` for `POST /contests/search`. */
export const PUSHER_SEARCH_ENDPOINT = '/search';
